const $$splitComponentImporter = () => import('/home/runner/work/nexus/nexus/apps/frontend/src/routes/(app)/org/$org/loop/$loopId/team-lens/index.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute, redirect } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { requirePermission } from '@/common/hooks/usePermissions';
import i18n from '@/common/translations/i18n';
import { ensureNamespaceLoaded } from '@/common/translations/i18nloader';
import { readLiveFlag } from '@/common/utils/readLiveFlag';
import { teamLensSearchSchema } from './-utils/searchParams';
type PermissionContext = Parameters<ReturnType<typeof requirePermission>>[0]['context'];
interface TeamLensBeforeLoadArgs {
  context: PermissionContext & {
    flagOverrides: Partial<FlagKeys>;
    flags: Partial<FlagKeys>;
    ldClient: LDClient | undefined;
  };
  params: {
    loopId: number;
    org: string;
  };
}
export async function teamLensBeforeLoad(args: TeamLensBeforeLoadArgs) {
  await requirePermission('edit_capacity')(args);
  if (!readLiveFlag(args.context, 'capacityTeamLens')) {
    throw redirect({
      params: args.params,
      replace: true,
      to: '/org/$org/loop/$loopId/teams'
    });
  }
  await ensureNamespaceLoaded('teams');
}
export const Route = createFileRoute('/(app)/org/$org/loop/$loopId/team-lens/')({
  beforeLoad: teamLensBeforeLoad,
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  validateSearch: zodValidator(teamLensSearchSchema),
  staticData: {
    topNav: {
      title: i18n.t($ => $.loops.teamLens)
    }
  }
});